import React, { useEffect, useState }  from "react";
import { Image, Descriptions  } from 'antd';
import Config from "../../../config/Config";
import WidgetAjax from '../../../widget/WidgetAjax';
import WidgetMessage from '../../../widget/WidgetMessage';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import Map from "../../com/map";

const basePath = Config.getBasePath();
const imgBasePath = Config.getFilePath();

const EnterpriseInfo = ({ info }) =>
{

    const [enterpriseFileList, setEnterpriseFileList] = useState([]);
    // 是否展示全部工商信息
    const [isShowAllInfo, setIsShowAllInfo] = useState(false);
    // 企业工作时间及福利
    const companyWelfare = [
        { icon: <img src={require('../../../img/pinzhunzhun/enterprise/time.png')} className="e_d_i_w_i" />, props: "" },
        { icon: <img src={require('../../../img/pinzhunzhun/enterprise/coffce.png')} className="e_d_i_w_i" />, props: "" },
    ];
    // 工商信息展示字段列表
    const enterpriseInfo = [
        { label: "企业名称", props: "ENTNAME" },
        { label: "法定代表人", props: "" },
        { label: "成立时间", props: "ESTDATE" },
        { label: "企业类型", props: "ENTTYPE_CN" },
        { label: "经营状态", props: "" },
        { label: "注册资本", props: "" },
        { label: "注册地址", props: "ADDRESS" },
        { label: "营业期限", props: "" },
        { label: "所属地区", props: "DISTRICT_CN" },
        { label: "统一社会信用代码", props: "UNISCID", span: 2 },
        { label: "核准日期", props: "" },
        { label: "曾用名", props: "", span: 3 },
        { label: "登记机关", props: "", span: 3 },
        { label: "所属行业", props: "INDTYPE_CN", span: 3 },
        { label: "经营范围", props: "MBSCOPE", span: 3 },
    ]

    /**
     * 加载企业环境照片
     */
    const loadEnterpriseEnvironmentList = () => {

        const onLoadEnterpriseEnvironmentList = (result, params) => {

            if (result.status === 0) {
                let enterpriseFileList = [];

                for (let item of result.results) 
                {
                    item.url = imgBasePath + "/enterprise/N" + item.id + ".png";

                    item.src = imgBasePath + "/enterprise/N" + item.id + ".png";

                    enterpriseFileList.push(item)
                }

                setEnterpriseFileList(enterpriseFileList)

            }
            else 
            {
                WidgetMessage.warning(result.message);
            }
        }


        if (info?.id) {

            let params = {
                enterprise_id: info.id

            }

            WidgetAjax.ajax({ url: basePath + "/enterprise/environment_list", params: params, callback: onLoadEnterpriseEnvironmentList });
        }
    }


    useEffect(() => {

        loadEnterpriseEnvironmentList();
    
    }, [info.id]);
    
    return (
        <div className="enterprise-detail-introduce" component-data={Config.getSourcePath()}>
            <div className="enterprise-detail-introduce-left">
                <div className="enterprise-detail-introduce-title">公司简介</div>
                <div dangerouslySetInnerHTML={{ __html: info.PROFILE || '-' }} className="enterprise-detail-introduce-content"></div>
                <div className="enterprise-detail-introduce-title">公司相册</div>
                <div className="sf-environment-body mb-20">
                    <span style={{ cursor: 'pointer', display: 'flex', flexWrap: 'wrap' }}>
                        {
                            enterpriseFileList && enterpriseFileList.length > 0 ?
                            enterpriseFileList.map((item) => {
                                    return <div style={{ marginRight: '16px', marginBottom: '16px' }}>
                                        <Image src={item.url} style={{ width: '200px', height: '160px' }} /> </div>
                                })
                                : '暂无环境照片'
                        }
                    </span>
                </div>
                <div className="enterprise-detail-introduce-title">人才发展</div>
                <div className="mb-20">暂无信息</div>
                <div className="enterprise-detail-introduce-title">产品介绍</div>
                <div className="mb-20">暂无信息</div>
                <div className="enterprise-detail-introduce-title">工商信息</div>
                <div className="enterprise-detail-business_info mb-20">
                    <Descriptions layout="vertical">
                        {
                            enterpriseInfo && enterpriseInfo.length > 0
                            ? enterpriseInfo.map((item, index) => {
                                if (index > 5)
                                {
                                    if (isShowAllInfo)
                                    {
                                        return (
                                            <Descriptions.Item label={item.label} key={index} span={item.span}>
                                                {item.props && item.props !=='' && info[item.props] ? info[item.props] : "-"}
                                            </Descriptions.Item>
                                        )
                                    }
                                } else {
                                    return (
                                        <Descriptions.Item label={item.label} key={index} span={item.span}>
                                            {item.props && item.props !=='' && info[item.props] ? info[item.props] : "-"}
                                        </Descriptions.Item>
                                    )
                                }
                            })
                            : <></>
                        }
                    </Descriptions>
                    <div 
                        className="check_more_info"
                        onClick={() => {
                            setIsShowAllInfo(!isShowAllInfo)
                        }}
                    >
                        {
                            isShowAllInfo
                            ?   <>
                                    <span>收起</span><CaretUpOutlined />
                                </>
                            :   <>
                                    <span>查看更多信息</span><CaretDownOutlined />
                                </>
                        }
                    </div>
                </div>
                <div className="enterprise-detail-introduce-title">公司地址</div>
                {
                    info.LOCATION && info.LOCATION.DISTRICT
                    ?   <div style={{ height: "300px" }}><Map lat={info.LOCATION.DISTRICT.LAT} lng={info.LOCATION.DISTRICT.LNG} /></div>
                    :   <></>
                }
                
            </div>
        </div>
    )
}

export default EnterpriseInfo;